import { render } from "./AboutHPPC.vue?vue&type=template&id=a599acfc&ts=true"
import script from "./AboutHPPC.vue?vue&type=script&lang=ts"
export * from "./AboutHPPC.vue?vue&type=script&lang=ts"

import "./AboutHPPC.vue?vue&type=style&index=0&id=a599acfc&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__